import { useSearchParams } from "react-router-dom"

export const useGetPrams = (name: string) => {
    const [searchParams] = useSearchParams()
    return searchParams.get(name)
}